import type { IconSvgObject } from './types';

const IndianRupeeIcon: IconSvgObject = [
  ["path", { d: "M6 3H9C11.7614 3 14 5.23858 14 8C14 10.7614 11.7614 13 9 13C7.75179 13 7.12769 13 6.86036 13.2016C6.53165 13.4496 6.38851 13.8737 6.49971 14.2701C6.59015 14.5925 7.08659 14.9707 8.07944 15.7272L15 21", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M6 3H18", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M6 8H18", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default IndianRupeeIcon;
